import { NavLink } from "react-router-dom";
import { NAV_GROUPS } from "../lib/nav";
import { PanelLeftClose, Languages } from "lucide-react";

export default function Sidebar({ collapsed, onToggle, onNavigate }) {
  return (
    <aside
      className={`relative flex h-full flex-col bg-[#231512] text-[#E9DED4] transition-all duration-300 ${
        collapsed ? "w-[74px]" : "w-64"
      }`}
      data-testid="admin-sidebar"
    >
      {/* warm glow accents */}
      <div className="pointer-events-none absolute -left-10 top-0 h-52 w-52 rounded-full bg-[#D84315]/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-10 -right-12 h-48 w-48 rounded-full bg-[#E5A93C]/10 blur-3xl" />

      {/* Brand */}
      <div className="relative flex h-[68px] items-center gap-3 border-b border-white/8 px-4">
        <div className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-[#E86A3A] to-[#BF360C] font-heading text-lg text-white shadow-[0_6px_18px_-6px_rgba(216,67,21,0.9)]">ॐ</div>
        {!collapsed && (
          <div className="min-w-0 flex-1">
            <p className="truncate font-heading text-[15px] font-semibold text-white">PurohithConnect™</p>
            <p className="truncate font-body text-[11px] tracking-wide text-[#A9968A]">Command center</p>
          </div>
        )}
        <button
          onClick={onToggle}
          className="hidden shrink-0 rounded-md p-1.5 text-[#A9968A] transition hover:bg-white/10 hover:text-white lg:block"
          data-testid="admin-sidebar-toggle"
          aria-label="Collapse sidebar"
        >
          <PanelLeftClose size={18} className={collapsed ? "rotate-180" : ""} />
        </button>
      </div>

      {/* Nav */}
      <nav className="relative flex-1 overflow-y-auto px-3 py-5">
        {NAV_GROUPS.map((group) => (
          <div key={group.label} className="mb-6">
            {!collapsed && (
              <p className="px-3 pb-2 font-body text-[10px] font-semibold uppercase tracking-[0.16em] text-[#8A776B]">
                {group.label}
              </p>
            )}
            <ul className="space-y-1">
              {group.items.map(({ to, end, icon: Icon, label }) => (
                <li key={to}>
                  <NavLink
                    to={to}
                    end={end}
                    onClick={onNavigate}
                    data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className={({ isActive }) =>
                      `group relative flex items-center gap-3 rounded-xl px-3 py-2.5 font-body text-[14px] transition-all duration-200 ${
                        isActive
                          ? "bg-gradient-to-r from-[#D84315] to-[#E86A3A] font-semibold text-white shadow-[0_10px_24px_-10px_rgba(216,67,21,0.9)]"
                          : "text-[#C6B6A9] hover:bg-white/[0.07] hover:text-white"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <Icon size={18} className={isActive ? "text-white" : "text-[#9A8578] group-hover:text-white"} />
                        {!collapsed && <span className="truncate">{label}</span>}
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="relative flex items-center justify-between border-t border-white/8 px-4 py-3">
        {!collapsed && (
          <span className="flex items-center gap-1.5 font-body text-xs text-[#A9968A]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#6BBF82]" /> Production
          </span>
        )}
        <button className="rounded-md p-1.5 text-[#A9968A] transition hover:bg-white/10 hover:text-white" aria-label="Language">
          <Languages size={16} />
        </button>
      </div>
    </aside>
  );
}
